//
//
//
//
//
//
//
//
export default {
  name: 'TrinityRingsSpinner',
  props: {
    animationDuration: {
      type: Number,
      "default": 1500
    },
    size: {
      type: Number,
      "default": 60
    },
    color: {
      type: String,
      "default": '#fff'
    }
  },
  data: function data() {
    return {
      containerPadding: 3
    };
  },
  computed: {
    outerRingSize: function outerRingSize() {
      return this.size - this.containerPadding * 2;
    },
    spinnerStyle: function spinnerStyle() {
      return {
        height: "".concat(this.size, "px"),
        width: "".concat(this.size, "px"),
        padding: "".concat(this.containerPadding, "px")
      };
    },
    ring1Style: function ring1Style() {
      return {
        height: "".concat(this.outerRingSize, "px"),
        width: "".concat(this.outerRingSize, "px"),
        borderColor: this.color,
        animationDuration: "".concat(this.animationDuration, "ms")
      };
    },
    ring2Style: function ring2Style() {
      return {
        height: "".concat(this.outerRingSize * 0.65, "px"),
        width: "".concat(this.outerRingSize * 0.65, "px"),
        borderColor: this.color,
        animationDuration: "".concat(this.animationDuration, "ms")
      };
    },
    ring3Style: function ring3Style() {
      return {
        height: "".concat(this.outerRingSize * 0.1, "px"),
        width: "".concat(this.outerRingSize * 0.1, "px"),
        borderColor: this.color,
        animationDuration: "".concat(this.animationDuration, "ms")
      };
    }
  }
};